import {
  SET_IS_DISPLAY_TITLE,
  SET_USER_NAME,
  SET_CAN_EDIT,
  SET_IS_NEW_FILE,
  SET_IS_NEW_FILE_MOBILE,
  UPDATE_NAVIGATION_LIST,
  UPDATE_NAVIGATION_LIST_SEARCH
} from "../constants";

export default (state = { isDisplayTitle: true, isNewFile: false, isNewFileMobile: true }, action) => {
  switch (action.type) {
    case SET_IS_DISPLAY_TITLE:
      return {
        ...state,
        isDisplayTitle: action.payload
      };
    case SET_USER_NAME:
      return {
        ...state,
        userName: action.payload
      };
    case SET_CAN_EDIT:
      return {
        ...state,
        canEdit: action.payload
      };
    case UPDATE_NAVIGATION_LIST:
      return {
        ...state,
        navigationList: action.payload
      };
      case UPDATE_NAVIGATION_LIST_SEARCH:
      return {
        ...state,
        navigationListSearch: action.payload
      };
    case SET_IS_NEW_FILE:
      return {
        ...state,
        isNewFile: action.payload
      };
    case SET_IS_NEW_FILE_MOBILE:
      return {
        ...state,
        isNewFileMobile: action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/widgetReducer.js